module.exports = "pegasus_template/assets/themecapture1/product/108.png";